// GetPage returns the body of the story cluster page
export const StoryClusterPageService_GetPageLazy = () =>
  import("./service.grpc").then((m) => m.StoryClusterPageService_GetPage);
StoryClusterPageService_GetPageLazy.method =
  "aysa_api.services.story_cluster_page.v1.StoryClusterPageService/GetPage" as const;

// Metadata [Web only]
export const StoryClusterPageService_MetadataLazy = () =>
  import("./service.grpc").then((m) => m.StoryClusterPageService_Metadata);
StoryClusterPageService_MetadataLazy.method =
  "aysa_api.services.story_cluster_page.v1.StoryClusterPageService/Metadata" as const;
